import React from 'react'
import Imageupload from '../Imageupload/Imageupload'
import TakeImage from '../TakeImage/TakeImage';
import './Home.css';
import VerificationScn from '../VerificationScreen/VerificationScn';
import loading2 from '../../images/loading2.gif';
import Loader from '../Loader/Loader';
import { faFile, faUpload, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useAppConfig } from '../../AppConfigProvider';


const Home = ({ fileBill, setFileBill, isImageUploaded, setIsImageUploaded, BillOCRDetails, setBillOCRDetails, setBillItems, setisFileTypeImg, setFullVendorsList, fullVendorsList, isNewVendor, setIsNewVendor, setOCRAddress, BillItems, handleDelete, addTableRows, onFormBillItemsValueChange, onFormVChange, isFileTypeImg, onVendorChange, isOCRVendor, OCRAddress, load, setLoad, uId, selectedOption, setSelectedOption, _onChange, selectedOptionAddress, setSelectedOptionAddress, _onChangeAddress, activeVendor, setActiveVendor, activeVendorFull, setActiveVendorFull }) => {
  const appConfig = useAppConfig();
  const publish = async () => {
    console.log("Load : ", load)
    setLoad(true);
    //   if(isNewVendor){
    //     console.log("is new supplier here bill ocr details",BillOCRDetails);
    //     const NewVendor = {
    //         vendorName:BillOCRDetails.vendorName,
    //         vendorAddress:BillOCRDetails.vendorAddress,
    //         vendorPhone:BillOCRDetails.vendorPhone,
    //         currency:BillOCRDetails.currency,
    //         userId: uId,
    //         isDeleted:false
    //     }
    //    await axios.post("http://localhost:8080/api/supplier/addSupplier", NewVendor).then(function(response){
    //         console.log("New Vendor response", response.data);
    //         BillOCRDetails.vendorId= response.data.id;
    //         setBillOCRDetails(BillOCRDetails);
    //     });
    // }
    // else{

    //     const OldVendorUpdate = {
    //         id:BillOCRDetails.vendorId,
    //         vendorName:BillOCRDetails.vendorName,
    //         vendorAddress:BillOCRDetails.vendorAddress,
    //         vendorPhone:BillOCRDetails.vendorPhone,
    //         currency:BillOCRDetails.currency,
    //         userId: uId,
    //         isDeleted:false
    //     }
    //     console.log("OLD Vendor response 111",OldVendorUpdate);
    //     axios.post("http://localhost:8080/api/supplier/updateSupplier", OldVendorUpdate).then(function(response){
    //         console.log("OLD Vendor response",OldVendorUpdate);
    //     });
    // }
    if (!isNewVendor) {
      axios.post(appConfig.backendUrl + "api/v1/bill", BillOCRDetails).then(function (response) {
        console.log("test", BillOCRDetails);
        console.log("active Vendor :", activeVendor);
        setTimeout(function () {
          setLoad(false);
          setIsImageUploaded({ isImage: false, isOcr: false });
          toast.success("Invoice Saved Successfully", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          console.log(response.data);
        }, 1000);
      }).catch(err => {
        setLoad(false);
        setIsImageUploaded({ isImage: false, isOcr: false });
        toast.error(`${err}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      });
    }
    else {
      setLoad(false);
      toast.error("Please save supplier before save invoice", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }

  }

  return (
    <div className='home-wrap'>
      {!load && <div className="file-card">
        {!isImageUploaded.isImage &&
          <>
            <div className="menu-card">
              <TakeImage />
            </div>
            <div className="menu-card">
              <Imageupload fileBill={fileBill} setFileBill={setFileBill} isImageUploaded={isImageUploaded} setIsImageUploaded={setIsImageUploaded} BillOCRDetails={BillOCRDetails} setBillOCRDetails={setBillOCRDetails} setBillItems={setBillItems} setisFileTypeImg={setisFileTypeImg} setFullVendorsList={setFullVendorsList} fullVendorsList={fullVendorsList} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} setOCRAddress={setOCRAddress} uId={uId} isFileTypeImg={isFileTypeImg} setSelectedOption={setSelectedOption} setSelectedOptionAddress={setSelectedOptionAddress} activeVendor={activeVendor} setActiveVendor={setActiveVendor} activeVendorFull={activeVendorFull} setActiveVendorFull={setActiveVendorFull} />
            </div>
            <div className="menu-card">
              <Link to="/uploadedDocs">
                <button>
                  <i><FontAwesomeIcon icon={faFile} /></i>
                  <span className='btn-span'>Uploaded Documents</span>
                </button>
              </Link>
            </div>
            <div className="menu-card">
              <Link to="/settings">
                <button>
                  <i><FontAwesomeIcon icon={faCog} /></i>
                  <span className='btn-span'>Settings</span>
                </button>
              </Link>
            </div>
            <div className="menu-card">
              <Link to="/pushQB">
                <button>
                  <i><FontAwesomeIcon icon={faUpload} /></i>
                  <span className="btn-span">Push Bills</span>
                </button>
              </Link>
            </div>
          </>
        }
        {isImageUploaded.isImage && !isImageUploaded.isOcr &&
          <div className='bill'>
            <img src={loading2} alt="loading" className='loadingImg' />
          </div>
        }
        {isImageUploaded.isOcr &&
          <VerificationScn uId={uId} setBillOCRDetails={setBillOCRDetails} BillOCRDetails={BillOCRDetails} setBillItems={setBillItems} BillItems={BillItems} handleDelete={handleDelete} addTableRows={addTableRows} onFormBillItemsValueChange={onFormBillItemsValueChange} onFormVChange={onFormVChange} isFileTypeImg={isFileTypeImg} fullVendorsList={fullVendorsList} onVendorChange={onVendorChange} isOCRVendor={isOCRVendor} OCRAddress={OCRAddress} isNewVendor={isNewVendor} load={load} setLoad={setLoad} setIsImageUploaded={setIsImageUploaded} publish={publish} setIsNewVendor={setIsNewVendor} selectedOption={selectedOption} setSelectedOption={setSelectedOption} _onChange={_onChange} selectedOptionAddress={selectedOptionAddress} setSelectedOptionAddress={setSelectedOptionAddress} _onChangeAddress={_onChangeAddress} activeVendor={activeVendor} setActiveVendor={setActiveVendor} setFullVendorsList={setFullVendorsList} activeVendorFull={activeVendorFull} setActiveVendorFull={setActiveVendorFull} />
        }
      </div>

      }
      {
        load && <Loader />
      }
      <ToastContainer />
    </div>
  )
}

export default Home